import { render, staticRenderFns } from "./Server.vue?vue&type=template&id=a6cf984c"
import script from "./Server.vue?vue&type=script&lang=js"
export * from "./Server.vue?vue&type=script&lang=js"
import style0 from "./Server.vue?vue&type=style&index=0&id=a6cf984c&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6cf984c')) {
      api.createRecord('a6cf984c', component.options)
    } else {
      api.reload('a6cf984c', component.options)
    }
    module.hot.accept("./Server.vue?vue&type=template&id=a6cf984c", function () {
      api.rerender('a6cf984c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/monitor/Server.vue"
export default component.exports